import { KeycloakIssuerRole, UserRole } from 'api';

export const transformUserRoleToIssuerRole = (role: UserRole): null | KeycloakIssuerRole => {
  if (role === UserRole.Issuer) {
    return KeycloakIssuerRole.SrIssuer;
  } else if (role === UserRole.IssuerAdmin) {
    return KeycloakIssuerRole.SrIssuerAdmin;
  }
  return null;
};
